import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import withReduxForm from './withReduxFormField'
import FieldBlock from '../forms/field-block'
import CtaButton from '../buttons/cta-button'
import FlatButton from '../buttons/flat-button'
import Notification from '../notifications/notification'
import { GridRow, GridCol } from '../grid/'
import InputField from '../forms/input-field'
import Label from '../texts/label'
import SmallText from '../texts/small-text'
import InfoBlock from '../texts/info-block'
import {
  normalizePhone,
  normalizeTinNumber
} from '../../services/normalizations'
import StripePowered from '../../styles/images/stripe/powered_by_stripe.png'
import StripeConnect from '../../styles/images/stripe/connect_stripe_light-on-dark.png'

const LabelledInput = withReduxForm(InputField)

const CharityLegalForm = props => {
  const {
    handleSubmit,
    handleCancel,
    submitting,
    submitFailed,
    ownerContactDetailText,
    ownerContactDetailHelperText,
    ownerContactDetailHelper2Text,
    firstNameLabel,
    lastNameLabel,
    emailLabel,
    phoneLabel,
    birthdateLabel,
    addressLabel,
    charityDetailsText,
    legalNameLabel,
    tinLabel,
    legalAddressLabel,
    stripeAccountLabel,
    stripeAccountHelperText,
    showConnectWithStripeButton,
    connectWithStripeLink,
    invalid,
    errorNotificationText,
    cancelText,
    saveText
  } = props
  return (
    <form onSubmit={handleSubmit}>
      <FieldBlock>
        <InfoBlock>
          <Label>{ownerContactDetailText}</Label>
          <SmallText>{ownerContactDetailHelperText}</SmallText>
          <SmallText>{ownerContactDetailHelper2Text}</SmallText>
        </InfoBlock>
        <Field
          component={LabelledInput}
          name='ownerName'
          type='text'
          id='owner-name'
          label={firstNameLabel}
          theme='dark-theme'
          autoFocus
        />
        <Field
          component={LabelledInput}
          name='ownerSurname'
          type='text'
          id='owner-surname'
          label={lastNameLabel}
          theme='dark-theme'
        />
        <Field
          component={LabelledInput}
          name='ownerEmail'
          type='email'
          id='owner-email'
          label={emailLabel}
          theme='dark-theme'
        />
        <Field
          component={LabelledInput}
          name='ownerPhone'
          type='text'
          id='owner-phone'
          label={phoneLabel}
          theme='dark-theme'
          normalize={normalizePhone}
        />
        <Field
          component={LabelledInput}
          name='ownerBirthdate'
          type='text'
          id='owner-birthdate'
          label={birthdateLabel}
          theme='dark-theme'
        />
        <Field
          component={LabelledInput}
          name='ownerAddress'
          type='text'
          id='owner-address'
          label={addressLabel}
          theme='dark-theme'
        />
      </FieldBlock>
      <FieldBlock className='label-space' titleLabel={charityDetailsText}>
        <Field
          component={LabelledInput}
          name='legalName'
          type='text'
          id='legal-name'
          label={legalNameLabel}
          theme='dark-theme'
        />
        <Field
          component={LabelledInput}
          name='tin'
          type='text'
          id='tin'
          label={tinLabel}
          theme='dark-theme'
          normalize={normalizeTinNumber}
        />
        <Field
          component={LabelledInput}
          name='legalAddress'
          type='text'
          id='legal-address'
          label={legalAddressLabel}
          theme='dark-theme'
        />
      </FieldBlock>
      {props.showStripeSection && (
        <FieldBlock hasHeader={false}>
          <InfoBlock>
            <a name='stripe'>
              <Label>{stripeAccountLabel}</Label>
            </a>
            <SmallText>{stripeAccountHelperText}</SmallText>
            <a
              rel='noopener noreferrer'
              target='_blank'
              href='http://www.stripe.com'
            >
              <img src={StripePowered} alt='Powered by stripe' />
            </a>
          </InfoBlock>
          {showConnectWithStripeButton ? (
            <a href={connectWithStripeLink}>
              <img src={StripeConnect} alt='Connect with Stripe' />
            </a>
          ) : (
            <Notification status='success'>
              <p>
                Your account is <strong>connected to Stripe</strong>.
              </p>
              <p>
                <a
                  rel='noopener noreferrer'
                  target='_blank'
                  href='https://dashboard.stripe.com'
                >
                  Go to your Stripe Dashboard
                </a>
              </p>
            </Notification>
          )}
        </FieldBlock>
      )}
      {submitFailed &&
        invalid && (
          <Notification status='error' iconName='warning' hasIcon>
            {errorNotificationText}
          </Notification>
        )}
      <GridRow className='bottom-space top-space'>
        <GridCol type='one-half'>
          <FlatButton
            text={cancelText}
            isInverse
            type='button'
            onClick={handleCancel}
            disabled={submitting}
          />
        </GridCol>
        <GridCol type='one-half pull-right'>
          <CtaButton
            hasIcon={false}
            text={saveText}
            type='submit'
            disabled={submitting}
            isLoading={submitting}
          />
        </GridCol>
      </GridRow>
    </form>
  )
}

CharityLegalForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleCancel: PropTypes.func,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
  submitFailed: PropTypes.bool,
  invalid: PropTypes.bool,
  // translations
  ownerContactDetailText: PropTypes.string,
  ownerContactDetailHelperText: PropTypes.string,
  ownerContactDetailHelper2Text: PropTypes.string,
  firstNameLabel: PropTypes.string,
  lastNameLabel: PropTypes.string,
  emailLabel: PropTypes.string,
  phoneLabel: PropTypes.string,
  birthdateLabel: PropTypes.string,
  addressLabel: PropTypes.string,
  charityDetailsText: PropTypes.string,
  legalNameLabel: PropTypes.string,
  tinLabel: PropTypes.string,
  legalAddressLabel: PropTypes.string,
  showStripeSection: PropTypes.bool,
  stripeAccountLabel: PropTypes.string,
  stripeAccountHelperText: PropTypes.string,
  showConnectWithStripeButton: PropTypes.bool,
  connectWithStripeLink: PropTypes.string,
  cancelText: PropTypes.string,
  saveText: PropTypes.string,
  errorNotificationText: PropTypes.string
}

export default CharityLegalForm



// WEBPACK FOOTER //
// ./src/ui/forms/charity-legal-form.js